module.exports = __webpack_public_path__ + "media/images/logo-everfactor-01-1c7e962c49a2d1ca499f2769ca213980.svg";